import * as Sentry from '@sentry/react';
import { OneUserLetterboxdData } from '../resources/Letterboxd';
import CurrentUserResource from '../resources/Auth/CurrentUser';

const REFRESH_COOLDOWN = 30_000; // 30 seconds

export let configureAppResumed = () => {
  if (typeof document === 'undefined') return;

  let lastRefreshTime = 0;

  document.addEventListener('visibilitychange', async () => {
    if (document.visibilityState !== 'visible') return;
    if (Date.now() - lastRefreshTime < REFRESH_COOLDOWN) return;

    lastRefreshTime = Date.now();

    try {
      let currentUser = await CurrentUserResource.UNSTABLE__getFromStoreOrGet(undefined);
      if (currentUser?.letterboxdId) {
        OneUserLetterboxdData.refresh(currentUser.letterboxdId);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  });
};
